// extracted by mini-css-extract-plugin
module.exports = {"container":"_11BXV","containerInner":"_1L4T6","containerInnerLeft":"_1Wxmv","containerInnerLeftTitle":"_2jOJ4","containerInnerLeftContent":"_30WEJ","containerInnerRight":"_1wvMs"};